<template>
    <nav class="border-t border-gray-200 px-4 flex items-center justify-between sm:px-0">
        <div class="-mt-px w-0 flex-1 flex">
            <Link
                v-if="previousPageUrl"
                :href="previousPageUrl"
                class="
                    border-t-2 border-transparent
                    pt-4
                    pr-1
                    inline-flex
                    items-center
                    text-sm
                    font-medium
                    text-gray-500
                    hover:text-gray-700
                    hover:border-gray-300
                "
            >
                <fa-icon icon="arrow-left" class="mr-3 text-xl text-gray-400"></fa-icon>
                Previous
            </Link>
        </div>
        <div class="hidden md:-mt-px md:flex flex-wrap">
            <Link
                v-for="page in pages"
                :key="page.url"
                :href="page.url"
                :class="
                    page.active
                        ? 'border-lightblue-500 text-lightblue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                "
                class="border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium"
            >
                {{ page.label }}
            </Link>
        </div>
        <div class="-mt-px w-0 flex-1 flex justify-end">
            <Link
                v-if="nextPageUrl"
                :href="nextPageUrl"
                class="
                    border-t-2 border-transparent
                    pt-4
                    pl-1
                    inline-flex
                    items-center
                    text-sm
                    font-medium
                    text-gray-500
                    hover:text-gray-700
                    hover:border-gray-300
                "
            >
                Next
                <fa-icon icon="arrow-right" class="ml-3 text-xl text-gray-400"></fa-icon>
            </Link>
        </div>
    </nav>
</template>

<script>
import FaIcon from "@/Components/FaIcon";

export default {
    name: "Pagination",
    components: { FaIcon },
    props: {
        nextPageUrl: {
            type: String,
            required: false,
        },
        previousPageUrl: {
            type: String,
            required: false,
        },
        pages: {
            type: Array,
            required: true,
        },
    },
};
</script>
